var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRingPhoneGraphics = function SvgIconRingPhoneGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 2006",
    fill: "#4b4b4b",
    d: "M0 0h41.896v41.182H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5730"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1992",
    fill: "#fff",
    opacity: 0.8,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5729"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5728",
    clipPath: "url(#a)",
    fill: "#4b4b4b",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4683",
    d: "M28.206 0H13.882a2.949 2.949 0 0 0-3.035 2.847v35.489a2.949 2.949 0 0 0 3.035 2.847h14.324a3.059 3.059 0 0 0 3.105-2.847V2.847A3.059 3.059 0 0 0 28.206 0Zm-9.992 2.081h5.745a.375.375 0 0 1 0 .749h-5.745a.374.374 0 1 1 0-.749Zm2.919 37.875a1.661 1.661 0 1 1 1.661-1.661 1.662 1.662 0 0 1-1.661 1.661m8.346-4.594-16.788.021-.008-30.408a.025.025 0 0 1 .017 0l16.788-.021Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4684",
    d: "M3.449 12.087c1.148-1.508 2.831-.058 1.64 1.334a11.713 11.713 0 0 0-2.747 4.843 10.348 10.348 0 0 0 .209 5.793 10.207 10.207 0 0 0 1.233 2.5c.471.7 1.39 1.387 1.39 2.3a.974.974 0 0 1-.91 1.067c-.795.032-1.47-1.108-1.87-1.66A12.808 12.808 0 0 1 .175 22.87a12.533 12.533 0 0 1 3.274-10.783c.334-.44-1.15 1.172 0 0Zm3.074 2.228c.677-.678 2.149-.881 2.025.488a2.531 2.531 0 0 1-.8 1.333 6.594 6.594 0 0 0-1.114 1.9 6.954 6.954 0 0 0-.252 4.116 6.763 6.763 0 0 0 .726 1.8c.38.646 1.091 1.173 1.358 1.864.482 1.243-.827 1.827-1.694 1.027a8.95 8.95 0 0 1-2.358-4.091 9.379 9.379 0 0 1 2.111-8.437c.376-.376-.816.983 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4685",
    d: "M38.446 29.189c-1.148 1.508-2.831.058-1.64-1.334a11.708 11.708 0 0 0 2.747-4.843 10.348 10.348 0 0 0-.209-5.793 10.213 10.213 0 0 0-1.233-2.5c-.472-.7-1.39-1.387-1.39-2.3a.975.975 0 0 1 .91-1.067c.795-.032 1.47 1.108 1.87 1.66a12.815 12.815 0 0 1 2.219 5.393 12.531 12.531 0 0 1-3.275 10.785c-.334.44 1.15-1.171 0 0Zm-3.074-2.227c-.677.677-2.149.881-2.025-.488a2.533 2.533 0 0 1 .8-1.333 6.6 6.6 0 0 0 1.115-1.9 6.959 6.959 0 0 0 .252-4.116 6.729 6.729 0 0 0-.726-1.8c-.38-.646-1.091-1.173-1.359-1.864-.481-1.243.827-1.827 1.694-1.027a8.942 8.942 0 0 1 2.358 4.09 9.382 9.382 0 0 1-2.111 8.438c-.376.376.816-.984 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4686",
    d: "M22.857 22.294a3.1 3.1 0 0 0-.86.536 22.242 22.242 0 0 1-1.166-2.415 22.749 22.749 0 0 1-.872-2.473 3.088 3.088 0 0 0 1.001-.227c1.594-.658 1.46-2.119.796-3.716s-1.604-2.722-3.2-2.061a3.1 3.1 0 0 0-1.57 1.438c-1.101 1.381-1.138 4.195.605 8.385 1.66 4.003 3.592 5.975 5.29 6.313a3.118 3.118 0 0 0 2.385.001c1.595-.658 1.46-2.12.796-3.715s-1.611-2.725-3.202-2.063Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRingPhoneGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-ring-phone-graphics.3846a65e.svg";
export { ForwardRef as ReactComponent };